import {
    Button,
    DialogContent,
    DialogContentText,
    Typography,
} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import { nanoid } from 'nanoid';

import { colors } from "../../../styles/colors";
import fontWeight from "../../../styles/mui/fontWeight";
import { ButtonMinWidth } from "../styles/style";
  
  export interface Props {
    formError: any;
    hasFormError: boolean;
    setHasFormError: (value: boolean) => void;
  }
const ErrorDialog = ({ hasFormError, setHasFormError, formError }: Props) => {
    return (
      <Dialog
        aria-describedby="alert-dialog-description"
        aria-labelledby="alert-dialog-title"
        disableScrollLock
        onClose={() => setHasFormError(false)}
        open={hasFormError}
      >
        <DialogTitle id="alert-dialog-title">
          <Typography
            color={colors.primary.main}
            fontWeight={fontWeight[4]}
            variant="h6"
          >
            Please check below details
          </Typography>
        </DialogTitle>
        <DialogContent>
          {Array.isArray(formError) ? (
            formError.map(
              (
                error: { name: string; message: string; type: string },
                index: number
              ) => (
                <DialogContentText
                  id="alert-dialog-description"
                  key={nanoid()}
                  mb={"0.5rem"}
                >
                  <Typography
                    color={colors.red[100]}
                    fontWeight={fontWeight[4]}
                    variant="subtitle1"
                  >
                    {index + 1}. {error.message}
                  </Typography>
                </DialogContentText>
              )
            )
          ) : (
            <DialogContentText id="alert-dialog-description" mb={"0.5rem"}>
              <Typography
                color={colors.red[100]}
                fontWeight={fontWeight[4]}
                variant="subtitle1"
              >
                {formError?.message ?? ""}
              </Typography>
            </DialogContentText>
          )}
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center" }}>
          <Button
            variant="contained"
            sx={ButtonMinWidth}
            onClick={() => setHasFormError(false)}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    );
  };
  
  export default ErrorDialog;
  